/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                this.bindEvents();
                this.scrollify();
                this.gameSlider();
                this.stickyHeader();
                this.pixie();
                this.carousel();
                this.parallax();
            },

            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            },

            isMobile: function () {
                var Android = navigator.userAgent.match(/Android/i);
                var BlackBerry = navigator.userAgent.match(/BlackBerry/i);
                var iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
                var Opera = navigator.userAgent.match(/iPhone|iPad|iPod/i);
                var Windows = navigator.userAgent.match(/IEMobile/i);
                return (Android || BlackBerry || iOS || Opera || Windows);
            },

            bindEvents: function () {
                var self = this;

                $("[data-scrollTo]").click(function (event) {
                    event.preventDefault();
                    var section = $(this).attr("data-scrollTo");
                    $("html, body").animate({scrollTop: $(section).offset().top}, 1000);
                });

                var iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);

                if (iOS) {
                    $('body').addClass('browser-ios');
                }

                $("#game-click-to-play").on('click', 'button', function (event) {
                    event.preventDefault();
                    self.gameLoader();
                });
            },

            parallax: function () {
                if ($.fn.parallax) {
                    alert('x');
                    $('.parallax-wrap').parallax({imageSrc: '/wp-content/themes/beefee/dist/images/bg-page-game.jpg'});
                    $('.parallax-game').parallax({imageSrc: '/wp-content/themes/beefee/dist/images/game-bg-min.jpg'});
                    $('.parallax-bg').parallax({imageSrc: '/wp-content/themes/beefee/dist/images/bg-page-postlist.jpg'});
                }
            },

            carousel: function () {
                if (!$.fn.slick) {
                    return;
                }

                $('.carousel-single').slick({
                    prevArrow: $('#slick-left'),
                    nextArrow: $('#slick-right'),
                    dots: true
                });

            },

            gameLoader: function () {
                var self = this;
                var iframeContainer = $("#game-wrapper");
                var gameContainer = $("#game-container");
                var gameUrl = iframeContainer.attr('data-game-url');

                if (gameUrl && gameContainer) {

                    var loader = $('#game-loader');

                    var progress_start = setInterval(function () {
                        self._progress(loader, 80);
                    }, 30);

                    $('body').addClass('game-loader');

                    var ifr = $('<iframe />', {
                        src: gameUrl,
                        load: function () {
                            clearInterval(progress_start);

                            progress_start = setInterval(function () {
                                self._progress(loader, 100);
                            }, 20);

                            setTimeout(
                                function () {
                                    clearInterval(progress_start);
                                    loader.text('100%');
                                    $('body').removeClass('game-loader');
                                    $('body').addClass('game-loaded');
                                }, 1000);
                        }
                    });

                    ifr.attr("frameborder", '0');
                    ifr.attr("scrolling", 'no');
                    gameContainer.append(ifr);
                }
            },

            _progress: function (el, max) {
                val = parseInt(el.text()) || 0;
                val = val + 1;

                if (val <= max) {
                    el.text(val + '%');
                }
            },

            stickyHeader: function () {
                $(window).on("scroll touchmove", function () {
                    $('body').toggleClass('sticky', $(document).scrollTop() > 0);
                });
            },

            scrollify: function () {
                $('.button-section-next').on('click', function (e) {
                    e.preventDefault();
                });
            },

            gameSlider: function () {
                var wallopEl = document.querySelector('.Wallop');
                var mainEl = document.querySelector('.game-footer-bg');

                if (!wallopEl) {
                    return;
                }

                var slider = new Wallop(wallopEl);
                var autoPlayMs = 600000;
                var nextTimeout;
                var loadNext = function () {
                    var nextIndex = (slider.currentItemIndex + 1) % slider.allItemsArray.length;
                    slider.goTo(nextIndex);
                };

                nextTimeout = setTimeout(function () {
                    loadNext();
                }, autoPlayMs);
                slider.on('change', function (event) {
                    var activeElement = slider.allItemsArray[event.detail.currentItemIndex];
                    var imgSlider = activeElement.getAttribute('data-img-slider');
                    var imgFooter = activeElement.getAttribute('data-img-footer');
                    activeElement.style.backgroundImage = 'url(' + imgSlider + ')';
                    mainEl.style.backgroundImage = 'url(' + imgFooter + ')';
                    clearTimeout(nextTimeout);
                    nextTimeout = setTimeout(function () {
                        loadNext();
                    }, autoPlayMs);
                });
            },

            pixie: function () {
                if (this.isMobile()) {
                    $('body').addClass('is-touch');
                    return;
                }

                var WIDTH = window.innerWidth,
                    HEIGHT = window.innerHeight,
                    MAX_PARTICLES = 80,
                    DRAW_INTERVAL = 20,
                    canvas = document.querySelector('#pixie'),
                    context = canvas.getContext('2d'),
                    gradient = null,
                    pixies = [];

                function setDimensions(e) {
                    WIDTH = window.innerWidth;
                    HEIGHT = window.innerHeight;
                    canvas.width = WIDTH;
                    canvas.height = HEIGHT;
                }

                setDimensions();
                window.addEventListener('resize', setDimensions);

                function Circle() {
                    this.settings = {
                        ttl: 8000,
                        xmax: 5,
                        ymax: 2,
                        rmax: 10,
                        rt: 1,
                        xdef: 960,
                        ydef: 540,
                        xdrift: 4,
                        ydrift: 4,
                        random: true,
                        blink: true
                    };

                    this.reset = function () {
                        this.x = (this.settings.random ? WIDTH * Math.random() : this.settings.xdef);
                        this.y = (this.settings.random ? HEIGHT * Math.random() : this.settings.ydef);
                        this.r = ((this.settings.rmax - 1) * Math.random()) + 1;
                        this.dx = (Math.random() * this.settings.xmax) * (Math.random() < 0.5 ? -1 : 1);
                        this.dy = (Math.random() * this.settings.ymax) * (Math.random() < 0.5 ? -1 : 1);
                        this.hl = (this.settings.ttl / DRAW_INTERVAL) * (this.r / this.settings.rmax);
                        this.rt = Math.random() * this.hl;
                        this.settings.rt = Math.random() + 1;
                        this.stop = Math.random() * 0.2 + 0.4;
                        this.settings.xdrift *= Math.random() * (Math.random() < 0.5 ? -1 : 1);
                        this.settings.ydrift *= Math.random() * (Math.random() < 0.5 ? -1 : 1);
                    };

                    this.fade = function () {
                        this.rt += this.settings.rt;
                    };

                    this.draw = function () {
                        if (this.settings.blink && (this.rt <= 0 || this.rt >= this.hl)) {
                            this.settings.rt = this.settings.rt * -1;
                        } else if (this.rt >= this.hl) {
                            //this.reset();
                        }

                        var newo = 1 - (this.rt / this.hl);
                        context.beginPath();
                        context.arc(this.x, this.y, this.r, 0, Math.PI * 2, true);
                        context.closePath();

                        var cr = this.r * newo;
                        gradient = context.createRadialGradient(this.x, this.y, 0, this.x, this.y, (cr <= 0 ? 1 : cr));
                        gradient.addColorStop(0.0, 'rgba(255,255,255,' + newo + ')');
                        gradient.addColorStop(this.stop, 'rgba(77,101,181,' + (newo * 0.6) + ')');
                        gradient.addColorStop(1.0, 'rgba(77,101,181,0)');


                        context.fillStyle = gradient;
                        context.fill();
                    };

                    this.move = function () {
                        this.x += (this.rt / this.hl) * this.dx;
                        this.y += (this.rt / this.hl) * this.dy;
                        if (this.x > WIDTH || this.x < 0) {
                            this.dx *= -1;
                        }
                        if (this.y > HEIGHT || this.y < 0) {
                            this.dy *= -1;
                        }
                    };

                    this.getX = function () {
                        return this.x;
                    };

                    this.getY = function () {
                        return this.y;
                    };
                }

                for (var i = 0; i < MAX_PARTICLES; i++) {
                    pixies.push(new Circle());
                    pixies[i].reset();
                }

                function draw() {
                    context.clearRect(0, 0, WIDTH, HEIGHT);
                    for (var i = 0; i < pixies.length; i++) {
                        pixies[i].fade();
                        pixies[i].move();
                        pixies[i].draw();
                    }
                }

                setInterval(draw, DRAW_INTERVAL);
            },

        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },

            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            },
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);


})(jQuery); // Fully reference jQuery after this point.






